import { configureStore } from "@reduxjs/toolkit";
import { confirmationApi } from "../services/confirmationApi";

export const store = configureStore({
  reducer: {
    [confirmationApi.reducerPath]: confirmationApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(confirmationApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
